var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "refund-shipping-card",
      class: { "highlighted-refund-shipping-card": _vm.refundShipping },
    },
    [
      _c("div", { staticClass: "flex-auto" }, [
        _c("div", { staticClass: "flex flex-row" }, [
          _c("div", { staticClass: "shipping-refund-info flex-auto" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.isShippingRefundDisabled
                    ? "No shipping costs to refund (Shipping refund may have been issued already)"
                    : "Refund the shipping cost?"
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex flex-row" }, [
          _c("div", { staticClass: "shipping-refund-amount" }, [
            _vm._v("\n        Refundable Shipping Amount: "),
            _c("span", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v("$" + _vm._s(_vm.shippingTotal)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("el-checkbox", {
        attrs: {
          disabled: _vm.isShippingRefundDisabled,
          value: _vm.refundShipping,
        },
        on: { change: _vm.toggleSelection },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }